import { render, staticRenderFns } from "./UserBrand.vue?vue&type=template&id=456350f6&"
import script from "./UserBrand.vue?vue&type=script&lang=ts&"
export * from "./UserBrand.vue?vue&type=script&lang=ts&"
import style0 from "./UserBrand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports